import { IconAlert } from "../../../../../../../shared/IconsComponent/icons"
import Loader from "../../../../../../../shared/Loader/Loader"
import { Modal, ModalBody } from "react-bootstrap"

const AIDiscardRecordingModal = (props) => {
    const { confimarionPopup, onClose, discardChanges } = { ...props }
    return (
        <Modal show={confimarionPopup} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal mw-370px w-auto">
            {/* {isLoading ? <Loader /> : null} */}
            <ModalBody>
                <div className='d-flex justify-content-between delete-header align-items-center mb-12 p-0'>
                    <p className="heading dark-clr fs-14">Discard Recording?</p>
                    <i className='icon-x-cros fs-20 dark-clr' onClick={onClose}></i>
                </div>
                <div className='undo-body p-0'>
                    <div className='ar-alert d-flex m-0  gap-1'>
                        <span className="d-flex mt-3px">
                            <IconAlert />
                        </span>
                        <p className='text ms-1'>Your recording has been paused. Do you want to discard it? This action cannot be undone.</p>
                    </div>
                </div>
            </ModalBody>

            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose} >Cancel</button>
                <button className='btn btn-danger px-10 h-100' onClick={discardChanges}>Discard</button>
            </div>
        </Modal>
    )
}

export default AIDiscardRecordingModal